import React from 'react';
import { connect } from 'react-redux';
import { Table } from 'semantic-ui-react';
import findResult from '@/utils/resultsHelper';
import { states } from '@/constants/lifecycle';
import urls, { codeUrl } from '@/constants/urls';
import { firstError } from '@/utils/errors';
import TableWrapper from '@/components/table/TableWrapper';
import NoRowsWrapper from '@/components/table/NoRowsWrapper';
import { findWithUUID } from '@/utils/uuidHelper';
import UsersGroupsTableHeader from '../components/UsersGroupsTableHeader';
import UsersGroupsTableColumns from '../components/UsersGroupsTableColumns';
import UsersGroupsTableRows from '../components/UsersGroupsTableRows';
import UsersGroupsAddRow from './UsersGroupsAddRow';
import { dismissUsersGroupsError, fetchUsersGroups, removeUsersGroup } from '../actions/userUsergroups';
import fetch from '../hooks/fetch';

const UsersGroupsTable = ({
  allowAdd,
  allowRead,
  allowRemove,
  allowCreate,
  category,
  errors,
  fetchData,
  newUserGroupCode,
  readStatus,
  removeGroup,
  user,
  usersGroups,
}) => {
  fetch.useFetchUsersGroups(fetchData, category, readStatus, user);
  return (
    <NoRowsWrapper
      canCreate={allowCreate}
      entity="groups"
      icon="users"
      readStatus={[readStatus]}
      items={usersGroups}
      url={codeUrl(urls.USER_GROUP, newUserGroupCode, '#')}
      showChildrenIfNoRows
    >
      <TableWrapper className="aridhia-users-groups-table" sticky>
        <UsersGroupsTableHeader
          error={firstError(errors)}
          onErrorDismiss={() => dismissUsersGroupsError(category, user)}
          readStatus={readStatus}
        >
          {allowAdd && (<UsersGroupsAddRow category={category} user={user} />)}
          {!allowAdd && (<UsersGroupsTableColumns allowRemove={allowRemove} />)}
        </UsersGroupsTableHeader>
        <Table.Body>
          <UsersGroupsTableRows
            allowRead={allowRead}
            allowRemove={allowRemove}
            category={category}
            items={usersGroups}
            removeGroup={removeGroup}
            user={user}
          />
        </Table.Body>
      </TableWrapper>
    </NoRowsWrapper>
  );
};

const mapStateToProps = ({
  auth: { users, role: { permissions: { usergroups } } },
  userGroups: { userGroups: { assign: { users: { results } } }, newUserGroupCode },
}, { category, code }) => {
  const user = findResult(users, category, code, 'uuid') || { uuid: '' };
  const item = findWithUUID(results, user.uuid) || {
    archived: true,
    userGroups: {
      results: [],
      readStatus: states.NONE,
      readErrors: [],
    },
  };

  return {
    allowAdd: !item.archived && usergroups.assign,
    allowCreate: usergroups.create,
    allowRead: usergroups.read,
    allowRemove: usergroups.assign,
    category: 'assign',
    errors: item.userGroups.readErrors,
    newUserGroupCode,
    readStatus: item.userGroups.readStatus,
    user,
    usersGroups: item.userGroups.results,
  };
};

const mapDispatchToProps = {
  fetchData: fetchUsersGroups,
  removeGroup: removeUsersGroup,
};

export default connect(mapStateToProps, mapDispatchToProps)(UsersGroupsTable);
